"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorHashBindingsSha1 = void 0;
const bus_hash_bindings_1 = require("@comunica/bus-hash-bindings");
const hash_js_1 = require("hash.js");
const rdf_string_1 = require("rdf-string");
const canonicalize = require('canonicalize');
/**
 * A comunica Memento Http Actor.
 */
class ActorHashBindingsSha1 extends bus_hash_bindings_1.ActorHashBindings {
    async test(action) {
        if (!action.allowHashCollisions) {
            throw new Error(`Actor ${this.name} can not provide hash functions without hash collisions`);
        }
        return true;
    }
    async run(action) {
        return {
            hashFunction: bindings => (0, hash_js_1.sha1)()
                .update(canonicalize(Object.fromEntries([...bindings]
                .map(([key, value]) => [(0, rdf_string_1.termToString)(key), (0, rdf_string_1.termToString)(value)]))))
                .digest('hex'),
            hashCollisions: true,
        };
    }
}
exports.ActorHashBindingsSha1 = ActorHashBindingsSha1;
//# sourceMappingURL=ActorHashBindingsSha1.js.map